export default "__VITE_ASSET__4fb1ddb1__"